import SopDetails from './SopDetails';
export default SopDetails;
